import script from "./DetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsModal.vue?vue&type=script&setup=true&lang=js"

import "./DetailsModal.vue?vue&type=style&index=0&id=21bcf198&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21bcf198"]])

export default __exports__